import { actionsDisabled } from '../../utils/actionsDisabled';
import { CancelTender } from '../../models/CancelTender';
import { CancelTenderButton } from '../../components/controls/buttons/cancelTenderButton';
import { CancelTenderModal } from '../../components/controls/modals/cancelTenderModal';
import { cancelTenders, fetchTendersByStatus } from '../../services/shipmentApi';
import { DefaultColumns } from './data';
import { GridColDef } from '@mui/x-data-grid-premium';
import { removeOrAddColumn, reorderColumn } from '../../utils/columnReorder';
import { StandardBoard } from '../../components/standardBoard';
import { Tender } from '../../models/tender';
import { useAuth } from '../../auth';
import { useCallback, useEffect, useState } from 'react';
import { columnDataFormatter } from '../../utils/columnDataFormatter';

export function PendingTenderBoard() {
    const columnsStorageKey = 'pendingBoardColumns';
    useEffect(() => {
        if (localStorage.getItem(columnsStorageKey)) {
            let columnObj = localStorage.getItem(columnsStorageKey);
            let obj = columnObj && JSON.parse(columnObj);

            if (obj) {
                let formattedColumns = columnDataFormatter(obj);
                setColumns(formattedColumns);
            }
        }
    }, [])

    const auth = useAuth()

    const [isLoading, setIsLoading] = useState(true);
    const [tenders, setTenders] = useState<Tender[]>([]);
    const [selectedShipments, setSelectedShipments] = useState<number[]>([]);
    const [isColumnsDialogOpen, setColumnsOpen] = useState(false);
    const [cancelModalOpen, setCancelModalOpen] = useState(false);
    const [columns, setColumns] = useState<GridColDef[]>(DefaultColumns);

    const fetchData = useCallback(async () => {
        const data = await fetchTendersByStatus('TenderPending');
        setTenders(data);
        setIsLoading(false);
    }, []);

    const cancelTenderForSelectedShipments = async (cancelComment: string) => {

        setCancelModalOpen(false);
        setIsLoading(true);

        let cancelTenderObj: CancelTender = {
            shipmentIDs: selectedShipments,
            comment: cancelComment
        };

        await cancelTenders(cancelTenderObj);
        await fetchData();
        setIsLoading(false);
    }

    const onColumnAddedRemoved = (column: any) => {
        let updatedColumns = removeOrAddColumn(columns, column, columnsStorageKey);
        setColumns(updatedColumns);
    }

    const onColumnIndexChange = (columnPropertyName: string, targetIndex: number) => {
        let updatedColumns = reorderColumn(columns, columnPropertyName, targetIndex, columnsStorageKey);
        setColumns(updatedColumns);
    }

    useEffect(() => {
        fetchData()
            .catch(console.error);;
    }, [fetchData])

    function onColumnsDialogClose() {
        setColumnsOpen(false);
        setCancelModalOpen(false);
    }

    return (
        <StandardBoard
            onRefreshButtonClick={fetchData}
            title='Pending Tender Board'
            primaryElement={<CancelTenderButton disabled={actionsDisabled(selectedShipments)} title='Cancel the shipment tenders' onClick={() => setCancelModalOpen(true)} />}
            gridProps={{
                filterStorageObject: 'pendingBoardFilters',
                groupingStorageObject: 'pendingBoardGrouping',
                setSelectedShipments: setSelectedShipments,
                tenders: tenders,
                onColumnIndexChange,
            }}
            columns={columns}
            isColumnsDialogOpen={isColumnsDialogOpen}
            onColumnsDialogChanged={onColumnAddedRemoved}
            onColumnsDialogClose={onColumnsDialogClose}
            isBackdropVisible={isLoading}
            onColumnButtonClick={() => setColumnsOpen(true)}
        >
            <CancelTenderModal open={cancelModalOpen} close={onColumnsDialogClose} confirmCancel={cancelTenderForSelectedShipments} />
        </StandardBoard>
    );
}